export default __webpack_public_path__ + "static/media/student.a326e4c9.svg";